<template>
	<div class="clearfix company-form-container rounded mt-4 mx-auto px-3 term_list">

        {{ clickSelectHeaderLeft }}
        <div class="row p-3 trz_dynamic_field_wrapper">



            <div v-for="(row, index) in header_column_selected_view" :key="index" class=" col-sm-12">  
                <div class="trz_field_values">
                    <b-input-group class="header-fields mb-2" >

                      
                        
                        <!-- <b-input-group-append>
                            <div class="trz_delete_button">
                                
                            </div>
                        </b-input-group-append> -->
                        <b-form-textarea  rows="3" max-rows="3" class = "d-inline-block p-1 px-3 mr-2 align-middle"   :value="stringView(row)"></b-form-textarea>
                        
                        <b-input-group-append>
                           
                            <b-button variant="error"><b-icon class="delete-btn-red" @click="removeEntryModal('header-left',row)" icon="trash-fill" role="button" aria-hidden="true" scale="1.2" ></b-icon></b-button>
                        </b-input-group-append>
                    </b-input-group>  
                </div>
            </div>

        </div>
           
            
        <div>
            <b-modal id="delete-modal" title="Are you sure you want to delete this Field?" hide-footer> 
                <br />
                <div style="height: 10px;clear:both;"> &nbsp;</div>
                <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeEntry(current_header_type,current_row)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
                <div style="height: 5px;clear:both;"> &nbsp;</div>
            </b-modal>
        </div>  
 
            <!-- <div class="col-sm-12 row mb-3 mt-3">
                <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" >
                    <b-dropdown id="dropdown-fields"  text="Select Footer Fields" ref="dropdown" class="mb-1 position-relative">
                        <b-dropdown-form>
                            <b-form-group @submit.stop.prevent>
                                <div class="form-group">
                                    <b-form-checkbox-group
                                        v-model="footer_column_selected"
                                        :options="column_options"                            
                                        switches 
                                        
                                    />
                                </div>
                                
                            </b-form-group>
                        </b-dropdown-form>
                    </b-dropdown>
                </div>
                <div class="d-inline-block ml-3 pt-2">{{footer_show_selected}} {{clickSelect2}}</div>
            </div>  -->

            <!-- <div class="col-sm-12 mb-3 mt-3">
                    <button v-on:click="formSubmit()"  class="btn btn-primary position-static">Save</button>
            </div> -->
           
	</div>

</template>
<style scoped>
.dashed_border{border-style: dashed !important;}

.pf_loan_terms_wrapper .term_list
{
    height: 0px;
    transition:  height 2s;
}

.show_terms .term_list
{
    height: 300px;
    transition:  height 0.5s;
    overflow-y: scroll;
}
.trz_dynamic_field_wrapper
{
    display: none;
}
.show_terms .trz_dynamic_field_wrapper
{
    display: block;
}
</style>
<script>
    export default{
        props: ['companyid','pageurl' , 'flg'],
        mounted() {

            
        }, 
        data(){
            return {  
                showoverlay:true,
                accindex:1,
                header_column_selected:[],
                header_2_column_selected:[],
                column_options:[],
                default_fields:[],
                header_column_selected_view:[],
                header_2_column_selected_view:[],
                footer_column_selected:[],
                footer_column_selected_view:[],
                header_show_selected:[],
                header_2_show_selected:[],
                footer_show_selected:[],
                disabled:true,
                company_info:[],
                payrun_delete_msg:'Are you sure you want to remove this field ?',
                atl_company_package_title : this.$atl_company_package_title,
                current_header_type:'',
                current_row:'',
                approvepass: '',
                incorrectpass: '',
                loading:'',
            }
        },
        methods:{            
            
            showPreview()
            {

            },
            getCompany:function(x , y)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/publicinfo' , {
                }).then(function(response){
                    this.company_info = response.data;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            removeEntryModal(type,value)
            { 
                this.current_header_type = type;
                this.current_row = value;
                this.$bvModal.show('delete-modal');
            },
            toRoman(n){
                if (!Number.isInteger(n)) return false; 
                var i, r, decimal , roman;
                r = "";
                decimal = [1,   4,   5,   9,  10,  40,  50,  90, 100, 400, 500, 900,1000];
                roman = ["I","IV", "V","IX", "X","XL", "L","XC", "C","CD", "D","CM", "M"];
                for (i = 12; i >= 0; i--) {
                    while (n >= decimal[i]) {
                        r += roman[i];
                        n -= decimal[i];
                    }
                }
            return r;

            },
            removeEntry(type,value)
            {  
                //console.log(value);
                this.$bvModal.hide('delete-modal');
                if(type == 'header-left') 
                {
                    const index = this.header_column_selected.indexOf(value);
                    console.log(index);
                    if (index > -1) 
                    {
                        this.header_column_selected.splice(index, 1);
                        console.log(index);
                        this.formSubmit(index);
                    }
                }
                
            }, 
            formSubmit() 
            {

                
                var text = JSON.stringify(this.header_column_selected);
                let formData = new FormData();
                formData.append('payslip_fields', text);  
                formData.append('company_id', this.companyid); 
                console.log(formData);                                      
                let currentObj = this;  
 
                axios.post(this.$api_url + '/company/pf-loan-reject-reason/save', formData)
                    .then(function (response) 
                    {               
                        //this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});

                    }.bind(this))
                    .catch(function (error) 
                    {
                        //this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
                    }); 

            },
            
            
            get_payslip_field_settings: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/pf-loan-reject-reason' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;
                    let final_header_column_selected = [];
                   
                    for (const [key, value] of Object.entries(company_access_settings_temp)) {

                        console.log(value);
                        if(value != '')
                        {
                            final_header_column_selected.push(value);
                        }

                    }

                   
                    this.header_column_selected = final_header_column_selected;

                }.bind(this));
            },
            stringView(str) {


                if(str=='etin')
                {
                    str = 'e-TIN No.';
                    return str;
                }
                else if(str=='jobposition')
                {
                    str = 'Job Position';
                    return str;
                }
                else if(str=='nid')
                {
                    str = 'NID';
                    return str;
                }
                else if(str=='branch')
                {
                    str = 'Work Location';
                    return str;
                }
        
                else if(str=='name')
                {
                    str = 'Employee';
                    return str;
                }
                else if(str=='employee_code')
                {
                    str = 'Employee ID';
                    return str;
                }
                else if(str=='joining_date')
                {
                    str = 'Date of Joining';

                    return str;
                }  
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            setcolumn: function()
            {
                this.$refs.dropdown.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }
        },
        created: function(){
          this.get_payslip_field_settings();
          this.getCompany(); 
        },
        computed: 
        {
            
            clickSelectHeaderLeft() 
            {    
                var lt = this.header_column_selected_view.length;
                
                this.header_column_selected_view = this.header_column_selected;
                if(this.header_column_selected_view.length !=  lt)
                {
                    this.header_column_selected_view = this.header_column_selected;
                    this.formSubmit();
                }
                
                this.header_show_selected = this.header_column_selected_view.join();
                this.header_show_selected = this.header_show_selected.replace('branch','work_location');
                this.header_show_selected = this.header_show_selected.replaceAll("_", " ");
                this.header_show_selected = this.header_show_selected.replaceAll(",", " , ");
                this.header_show_selected = this.capitalizeTheFirstLetterOfEachWord(this.header_show_selected);
                
                if(this.header_column_selected.length ==0)
                {
                    this.header_show_selected = 'None Selected';
                }
                
                
                

            },
          
           
        }
    }
</script>
<style>
.company-form-container .custom-control-label::before {
	top: 2px !important;
}
.trz_delete_button {
	position: absolute;
	right: -25px;
	top: 6px;
}  
.trz_field_values .header-fields {
	position: relative;
}

.trz_dynamic_field_wrapper .dropdown-menu.show .custom-control.custom-control-inline.custom-switch {
	width: 100%;
}
</style>